import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SearchServiceOrderService } from './search-service-order.service';
import { buttonStatus, getStatusClass } from '../../../shared/constants/button-class';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import { ellipsisOptions, ellipsisHeaderOptions } from '../../../shared/constants/ellipsis-options';
import { KeyMap } from '../../../shared/interface/key-map.interface';
import { v4 as uuidv4 } from 'uuid';
import { TabsService } from '../../../services/tabs.service';
import { Tab } from '../../../services/tab';
import { Subscription } from 'rxjs';
import {
  IRoleAuthorizationService,
  AuthorizationType,
} from 'src/app/interfaces/role-authorization.interface';
import { RoleAuthorizationService } from 'src/app/services/role-authorization.service';
import { AzureLoginService } from 'src/app/services/azure-login.service';
import { generalDateFormatter } from '../../../shared/utilities/date-utilities';
import { ActivatedRoute, Router } from '@angular/router';
import { copy } from '../../../shared/utilities/common-utilities';
import { RolePermissionService } from '../../../common/role-permission.service';
import { ApiConfigService } from '../../../services/api-config.service';
import {
  onTableColumnChange,
  resolveSelectedColumns,
} from '../../../shared/utilities/crm-table-utilities';

@Component({
  standalone: false,
  selector: 'search-service-order',
  templateUrl: 'search-service-order.template.html',
  styleUrls: ['../../../shared/styles/crm-table.scss'],
  providers: [SearchServiceOrderService],
})
export class SearchServiceOrderComponent implements OnInit, OnDestroy {
  @Input() searchParams: any;
  dataList: any[];
  cols: any[];
  btnStatus: any = buttonStatus;
  selectedItem: any;
  // Delete is hidden from Search Service Order row ellipsis without affecting
  // other components that share the `ellipsisOptions` constant.
  ellipsisOptions: any[] = ellipsisOptions
    .map((object) => ({ ...object }))
    .filter((option) => option.label !== 'Delete');
  ellipsisHeaderOptions: any[] = copy(ellipsisHeaderOptions);
  ellipsisOptionsSec: any;
  ellipsisHeaderOptionsSec: any;
  private ssdMenuBaselineReady = false;
  private ssdHeaderBaseline: any[];
  private ssdRowBaseline: any[];
  selectedEllipsisItem: any;
  clonedRowData: KeyMap = {};
  isEditing: boolean;
  editConstant: string;
  status: any[];
  newTab: Tab;
  op: Popover;
  querySubscription: Subscription;
  mutationSubscriptions: Subscription[] = [];
  isLoading: boolean;
  getStatusClass: any = getStatusClass;
  authDetails: IRoleAuthorizationService;
  offsetLimit = 10;
  lastOffsetVal = 0;
  resultCount = 0;
  disableLoadMore = false;
  selectedColumns: any[];
  private readonly tableColumnId = 'search-service-order';
  baseSearchParams = null;
  isDirectOpenInfo = null;
  urlSubscriptions: Subscription;
  title: string = 'Search Order Results ( ' + this.resultCount + ' item(s) found)';
  constructor(
    private searchServiceOrderService: SearchServiceOrderService,
    private tabService: TabsService,
    private roleService: RoleAuthorizationService,
    private azureService: AzureLoginService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rps: RolePermissionService,
    private apiConfigService: ApiConfigService,
  ) {}

  ngOnInit() {
    this.urlSubscriptions = this.activatedRoute.queryParams.subscribe((params) => {
      if (Object.keys(params).length) {
        this.isDirectOpenInfo = {};
        this.isDirectOpenInfo = params;
      }
      this.router.navigate([], {
        queryParams: null,
        replaceUrl: true,
        relativeTo: this.activatedRoute,
      });
    });
    this.dataList = [];
    this.authDetails = {
      authorizationType: AuthorizationType.OptionList,
      component: SearchServiceOrderComponent,
      generalArray: this.ellipsisOptions,
    };
    this.ellipsisOptions = Object.assign(this.roleService.applyAuthorization(this.authDetails));
    this.editConstant = uuidv4();
    this.status = [
      { label: 'Active', value: 'Active' },
      { label: 'Terminated', value: 'Terminated' },
    ];
    this.cols = [
      { field: 'status', header: 'STATUS', type: 'text' },
      { field: 'subcategoryDescription', header: 'SUBCATEGORY DESCRIPTION', type: 'text' },
      { field: 'serviceOrderNumber', header: 'Service Order #', type: 'text' },
      { field: 'contractNumber', header: 'CONTRACT#', type: 'text' },
      { field: 'uniqueId', header: 'UNIQUE ID', type: 'text' },
      { field: 'invoiceNumber', header: 'INVOICE#', type: 'text' },
      { field: 'phoneNumber', header: 'PHONE NUMBER', type: 'text' },
      { field: 'contactFirstName', header: 'CONTACT FIRST NAME', type: 'text' },
      { field: 'contactLastName', header: 'CONTACT LAST NAME', type: 'text' },
      { field: 'dispatchDate', header: 'DISPATCH DATE', type: 'text' },
      { field: 'servicer', header: 'SERVICER NAME/PROVIDER', type: 'text' },
      { field: 'serviceStatus', header: 'SERVICE STATUS', type: 'text' },
      { field: 'checkNumber', header: 'CHECK #', type: 'text' },
      { field: 'claimNumber', header: 'CLAIM #', type: 'text' },
      { field: 'checkAmount', header: 'CHECK AMOUNT', type: 'text' },
      { field: 'pic', header: 'PIC', type: 'text' },
      { field: 'preApprovedDate', header: 'PRE-APPROVED DATE', type: 'text' },
      { field: 'claimPriorityCode', header: 'CLAIM PRIO CODE', type: 'text' },
      { field: 'claimDate', header: 'CLAIM START DATE', type: 'text' },
      { field: 'dateOfRepair', header: 'DATE OF REPAIR', type: 'text' },
      { field: 'submitForPaymentDate', header: 'SUBMIT FOR PAYMENT DATE', type: 'text' },
      { field: 'approvedForPaymentDate', header: 'APPROVED FOR PAYMENT DATE', type: 'text' },
      { field: 'manufacturer', header: 'MANUFACTURER', type: 'text' },
      { field: 'modelNumber', header: 'MODEL NUMBER', type: 'text' },
      { field: 'serialNumber', header: 'SERIAL NUMBER', type: 'text' },
      { field: 'customerFeedback', header: 'CUST FEEDBACK', type: 'text' },
      { field: 'authorizationCode', header: 'AUTH CODE', type: 'text' },
      { field: 'technicianName', header: 'TECH NAME', type: 'text' },
      { field: 'assignedTo', header: 'ASSIGNED TO', type: 'text' },
      { field: 'claimPaymentDate', header: 'CLAIM PAYMENT DATE', type: 'text' },
      { field: 'createdBy', header: 'CREATED BY', type: 'text' }
    ];
    this.selectedColumns = resolveSelectedColumns(
      this.tableColumnId,
      this.cols,
      this.cols.slice(0, 12),
    );

    if (this.isDirectOpenInfo) {
      this.searchParams = Object.assign(
        this.searchParams ? this.searchParams : {},
        this.isDirectOpenInfo,
      );
    }
    this.loadServiceOrders();

    this.doEvaluateRolePermissions();
    this.mutationSubscriptions.push(
      this.azureService.rolePermissionsUpdated$.subscribe(() => this.doEvaluateRolePermissions()),
    );
  }

  onColumnChange(): void {
    this.selectedColumns = this.selectedColumns.sort((a, b) => {
      return this.cols.findIndex((col) => col.field === a.field) - this.cols.findIndex((col) => col.field === b.field);
    });
    this.selectedColumns = onTableColumnChange(
      this.tableColumnId,
      this.cols,
      this.selectedColumns,
    );
  }

  doEvaluateRolePermissions() {
    if (!this.ssdMenuBaselineReady) {
      this.ssdHeaderBaseline = copy(this.ellipsisHeaderOptions);
      this.ssdRowBaseline = this.ellipsisOptions.map((option) => ({ ...option }));
      this.ssdMenuBaselineReady = true;
    }
    this.ellipsisHeaderOptions = copy(this.ssdHeaderBaseline);
    this.ellipsisOptions = this.ssdRowBaseline.map((option) => ({ ...option }));
    this.ellipsisHeaderOptionsSec = {
      type: 'three-dots',
      operation: 'ADD',
      permission: 'Claim',
      category: 'Claim',
    };
    this.ellipsisHeaderOptions = this.rps.evaluate(
      this.ellipsisHeaderOptionsSec,
      this.ellipsisHeaderOptions,
    );
    this.ellipsisOptionsSec = {
      type: 'three-dots',
      operation: 'EDIT-DELETE',
      permission: 'Claim',
      category: 'Claim',
    };
    this.ellipsisOptions = this.rps.evaluate(this.ellipsisOptionsSec, this.ellipsisOptions);
    this.ellipsisOptions = this.ellipsisOptions.filter((option) => option.label !== 'Delete');
    const access = this.roleService.ssdServiceOrderAccess();
    if (!access) {
      return;
    }
    if (!access.canEdit) {
      this.ellipsisOptions = this.ellipsisOptions.filter(
        (option) => String(option.value).toLowerCase() !== 'edit',
      );
    }
  }

  ellipsisClick(event: MouseEvent, item: any, popover: Popover) {
    this.selectedItem = item;
    toggleEllipsisPopover(event, popover);
  }

  ellipsisOptionClick(event, Popover: Popover) {
    this.newTab = { header: 'Service Order', content: this.selectedItem, type: 'Service Order' };
    this.tabService.createTab(this.newTab);
    Popover.hide();
  }
  openTab(data: any) {
    this.newTab = {
      header: `Service Order [ ${data && data.serviceOrderNumber} ]`,
      content: data,
      type: 'Service Order',
    };
    this.tabService.createTab(this.newTab);
  }
  openContract(data: any) {
    // For the dashboard, it has contractsId from ClaimHistory, and no contractsIdOriginal.
    const searchId = data.contractsIdOriginal ? data.contractsIdOriginal : data.contractId;
    const tabContent = {
      originalId: searchId,
      customerIdOriginal: data.customerId,
      uniqueId: data.uniqueId,
    };
    this.newTab = {
      header: `Contract [ ${data && data.contractNumber} ]`,
      content: tabContent,
      type: 'Contract',
    };
    this.tabService.createTab(this.newTab);
  }

  loadServiceOrders() {
    this.isLoading = true;
    this.searchParams = this.searchParams
      ? this.searchParams
      : { status: { key: 'APPROVED', value: 'APPROVED' } };
    this.baseSearchParams = Object.assign({}, this.searchParams);
    const searchQuery = Object.assign(
      {},
      this.searchParams,
      {
        limit: this.offsetLimit,
        offset: this.lastOffsetVal,
        azureUserId: this.azureService.accountId,
      },
    );

    this.lastOffsetVal += this.offsetLimit;
    this.querySubscription = this.searchServiceOrderService
      .getServiceOrderSearchResult(
        searchQuery,
        searchQuery.offset,
        searchQuery.limit,
      )
      .subscribe(
        ({ data, loading }: any) => {
          this.isLoading = loading;
          const modifedData = this.searchParams.fromDashboard
            ? data.getDashboardRecordDetails
            : data.getClaimsSearchResults.map((item) => {
                return { ...item };
              });
          const handoffTracing =
            !this.searchParams.fromDashboard &&
            (this.searchParams.isQuerySearch === true ||
              (this.isDirectOpenInfo && Object.keys(this.isDirectOpenInfo).length > 0));
          const routeHandoff = this.isDirectOpenInfo && Object.keys(this.isDirectOpenInfo).length > 0;

          if (modifedData.length) {
            let displayRows = modifedData;
            let primaryKeyUsed = false;
            if (handoffTracing) {
              const claimNumberData = this.searchParams.claimNumber
                ? displayRows.filter((el) => el.claimNumber === this.searchParams.claimNumber)
                : [];
              if (claimNumberData.length > 0) {
                displayRows = claimNumberData;
                primaryKeyUsed = true;
              }
            }
            const shouldAutoOpen =
              (routeHandoff || this.searchParams.isQuerySearch === true) &&
              (displayRows.length === 1 ||
                (this.searchParams.claimNumber &&
                  displayRows.filter((el) => el.claimNumber !== this.searchParams.claimNumber)
                    .length === 0));
            if (shouldAutoOpen) {
              if (handoffTracing) {
                this.insertQueryParameter([displayRows[0]], primaryKeyUsed);
              }
              if (routeHandoff) {
                this.isDirectOpenInfo = null;
                this.urlSubscriptions.unsubscribe();
              }
              this.searchParams = null;
              this.tabService.createTab({
                header: 'Service Order',
                content: displayRows[0],
                type: 'Service Order',
              });
            } else {
              this.disableLoadMore =
                Boolean(displayRows.length < this.offsetLimit) || !Boolean(displayRows.length);
              const formattedData = this.setDateFormat(displayRows);
              this.dataList = !!this.dataList
                ? [...this.dataList, ...formattedData]
                : [...formattedData];
              this.resultCount = this.dataList.length;
              if (handoffTracing) {
                this.insertQueryParameter(displayRows, primaryKeyUsed);
              }
            }
          } else if (handoffTracing) {
            this.insertQueryParameter([], false);
          }
        },
        (err) => {
          this.isLoading = false;
          throw err;
        },
      );
  }

  insertQueryParameter(rows, primaryKeyUsed = false) {
    const queryParameterResultsConfig = this.apiConfigService.getApiConfig('QueryParameterResults');
    let queryParameterResultsConfigValues = [];
    if (queryParameterResultsConfig) {
      queryParameterResultsConfigValues = Object.values(queryParameterResultsConfig);
    }
    const claimSearchValues = queryParameterResultsConfigValues.filter(
      (el: { configType: string }) => el.configType === 'ClaimSearch',
    );
    let insertTableValues = [];
    if (claimSearchValues && claimSearchValues.length > 0) {
      insertTableValues = claimSearchValues.map((x: { configKey: string; configValue: string }) => ({
        key: x.configKey,
        value: x.configValue,
      }));
    }
    const insertTableActive =
      insertTableValues && insertTableValues.length > 0 && insertTableValues[0].value === 'yes'
        ? true
        : false;
    if (!this.baseSearchParams) {
      return;
    }
    delete this.baseSearchParams.limit;
    delete this.baseSearchParams.offset;
    delete this.baseSearchParams.azureUserId;
    delete this.baseSearchParams.isQuerySearch;
    if (insertTableActive) {
      const phoneDigits =
        this.searchParams && this.searchParams.phoneNumber != null && this.searchParams.phoneNumber !== ''
          ? String(this.searchParams.phoneNumber).replace(/[^0-9]/g, '')
          : null;
      const parameter2 =
        this.searchParams && this.searchParams.claimNumber != null && this.searchParams.claimNumber !== ''
          ? String(this.searchParams.claimNumber)
          : this.searchParams && this.searchParams.serviceOrderNumber != null &&
              this.searchParams.serviceOrderNumber !== ''
            ? String(this.searchParams.serviceOrderNumber)
            : null;

      this.mutationSubscriptions.push(
        this.searchServiceOrderService
          .addQueryParameterResults({
            moduleName: 'claims',
            resultsCount: rows.length ? rows.length : 0,
            allParameters: JSON.stringify(this.baseSearchParams),
            insertUserName: this.azureService.accountId,
            parameter1: phoneDigits,
            parameter2,
            tenantId: 1,
            primaryKeyUsed,
          })
          .subscribe(
            (_res: unknown) => {},
            () => {
              console.log('Failed addQueryParameterResults');
            },
          ),
      );
    }
  }

  setDateFormat(data: any[]) {
    const dataList = data.map((e) => {
      const d = Object.assign({}, e);
      d.preApprovedDate = generalDateFormatter(d.preApprovedDate);
      d.claimDate = generalDateFormatter(d.claimDate);
      d.dateOfRepair = generalDateFormatter(d.dateOfRepair);
      d.submitForPaymentDate = generalDateFormatter(d.submitForPaymentDate);
      d.approvedForPaymentDate = generalDateFormatter(d.approvedForPaymentDate);
      d.claimPaymentDate = generalDateFormatter(d.claimPaymentDate);
      d.dispatchDate = generalDateFormatter(d.dispatchDate);
      return { ...d };
    });
    return dataList;
  }

  ngOnDestroy() {
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
    if (this.urlSubscriptions) {
      this.urlSubscriptions.unsubscribe();
    }
    this.mutationSubscriptions.forEach((subs) => subs.unsubscribe());
  }
}
